import React, { useState, useEffect, useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import Modal from '@material-ui/core/Modal'
import useBuildingsApi from '../../hooks/buildings/useBuildingsApi'
import useApartmentsApi from '../../hooks/apartments/useApartmentsApi'
import useDoorbellsApi from '../../hooks/doorbells/useDoorbellsApi'
import useUsersApi from '../../hooks/users/useUsersApi'
import ApartmentForm from './ApartmentForm'
import DoorbellForm from './DoorbellForm'
import UserForm from '../users/UserForm'
import useToastContext from '../../hooks/useToastContext'
import UserList from '../users/UserList'
import { DoorbellType } from '../../utils/constants'
import DeleteConfirmationModal from '../common/DeleteConfirmationModal'
import CustomTable from '../customTable/CustomTable'
import CopyIcon from '../../images/copy_clipboard.svg'
import copy from 'copy-to-clipboard'
import { QRCodeCanvas } from 'qrcode.react'
import { notificationTypes } from '../../contexts/toastContext'
import {
  useHistory,
  useLocation,
} from 'react-router-dom/cjs/react-router-dom.min'
import ListHeader from '../common/ListHeader'
import { paths } from '../../utils/paths'

const apartmentColumns = [
  { id: 'name', label: 'Nombre', minWidth: 130 },
  { id: 'sipUser', label: 'Usuario SIP', minWidth: 130 },
  { id: 'notificationNumber', label: '# Notificación', minWidth: 130 },
  { id: 'enabledFloors', label: 'Pisos habilitados', minWidth: 130 },
  { id: '', label: '', minWidth: 5 },
]

const userCollumns = [
  { id: 'name', label: 'Nombre', minWidth: 100 },
  { id: 'surname', label: 'Apellido', minWidth: 100 },
  { id: 'email', label: 'Email', minWidth: 100 },
  { id: 'phone', label: 'Teléfono', minWidth: 100 },
  { id: 'type', label: 'Tipo', minWidth: 100 },
  { id: '', label: '', minWidth: 5 },
]

const tabNames = {
  USERS: 'USERS',
  APARTMENTS: 'APARTMENTS',
  DOORBELS: 'DOORBELS',
  GATES: 'GATES',
}

export default function BuildingDetail() {
  const doorbellColumns = [
    { id: '', label: '', minWidth: 5 },

    {
      id: 'id',
      label: 'Id',
      minWidth: '100',
      format: (doorbell) => {
        return (
          <>
            <img
              src={CopyIcon}
              alt="copy to clipboard"
              style={{
                height: '20px',
                width: '20px',
                cursor: 'pointer',
              }}
              onClick={() => {
                copy(doorbell.id)
                addToast(
                  notificationTypes.success,
                  'Id del Portero copiado con exito!'
                )
              }}
            ></img>
            <div id={`Qrcode-${doorbell.id}`}>
              <QRCodeCanvas
                size={1024}
                style={{ display: 'none' }}
                value={`${window.location.origin}/requestAccess/${doorbell.id}`}
              />
            </div>
          </>
        )
      },
    },
    {
      id: 'image',
      label: 'Imagen',
      minWidth: '100',
      format: (doorbell) => {
        return doorbell.image ? (
          <img
            src={doorbell.image}
            alt="doorbell img"
            style={{ width: '70px' }}
          ></img>
        ) : (
          <p style={{ textAlign: 'center' }}>Sin imagen</p>
        )
      },
    },
    { id: 'name', label: 'Nombre', minWidth: 170 },
    {
      id: 'isEntrance',
      label: 'Entrada/Salida',
      minWidth: 100,
      format: (doorbell) => {
        return doorbell.isEntrance ? 'Entrada' : 'Salida'
      },
    },
    { id: 'rtspURL', label: 'URL RTSP', minWidth: 100 },
    {
      id: 'sip',
      label: 'SIP',
      minWidth: 100,
    },
    // { id: 'wssURL', label: 'URL WSS', minWidth: 100 },
    { id: 'description', label: 'Descripcion', minWidth: 100 },
    { id: 'type', label: 'Tipo', minWidth: 100 },
    { id: 'doorbelURL', label: 'URL portero', minWidth: 100 },
    { id: 'user', label: 'Usuario', minWidth: 100 },
    {
      id: 'portraitFormat',
      label: 'Portrait',
      minWidth: 50,
      format: (doorbell) => {
        return doorbell.portraitFormat ? 'Si' : 'No'
      },
    },
    {
      id: 'openDoorEnabled',
      label: 'Abrir puerta',
      minWidth: 80,
      format: (doorbell) => {
        return doorbell.openDoorEnabled ? 'Si' : 'No'
      },
    },
    {
      id: 'webrtcURL',
      label: 'WebRTC',
      minWidth: 80,
      format: (doorbell) => {
        return doorbell.webrtcURL ? 'Si' : 'No'
      },
    },
  ]

  const gateColumns = [
    {
      id: 'id',
      label: 'Id',
      minWidth: '100',
      format: (doorbell) => {
        return (
          <>
            <img
              src={CopyIcon}
              alt="copy to clipboard"
              style={{
                height: '20px',
                width: '20px',
                cursor: 'pointer',
              }}
              onClick={() => {
                copy(doorbell.id)
                addToast(
                  notificationTypes.success,
                  'Id del Portero copiado con exito!'
                )
              }}
            ></img>
            <div id={`Qrcode-${doorbell.id}`}>
              <QRCodeCanvas
                size={1024}
                style={{ display: 'none' }}
                value={`${window.location.origin}/requestAccess/${doorbell.id}`}
              />
            </div>
          </>
        )
      },
    },
    { id: 'name', label: 'Nombre', minWidth: 170 },
    // { id: 'wssURL', label: 'URL WSS', minWidth: 100 },
    { id: 'description', label: 'Descripcion', minWidth: 100 },
    { id: 'type', label: 'Tipo', minWidth: 100 },
    { id: 'doorbelURL', label: 'URL portero', minWidth: 100 },
    { id: 'user', label: 'Usuario', minWidth: 100 },
    {
      id: 'openDoorEnabled',
      label: 'Abrir puerta',
      minWidth: 80,
      format: (doorbell) => {
        return doorbell.openDoorEnabled ? 'Si' : 'No'
      },
    },
    { id: 'idRelay', label: 'Id relay', minWidth: 100 },
    { id: 'groupId', label: 'Grupo', minWidth: 100 },
    { id: 'rtspURL', label: 'URL RTSP', minWidth: 100 },
    {
      id: 'webrtcURL',
      label: 'WebRTC',
      minWidth: 80,
      format: (doorbell) => {
        return doorbell.webrtcURL ? 'Si' : 'No'
      },
    },
    { id: '', label: '', minWidth: 5 },
  ]
  const addToast = useToastContext()
  const classes = useStyles()
  const history = useHistory()
  const location = useLocation()
  const { selectedTab: tabToSelect } = location.state || {}
  let { id } = useParams()
  const [selectedTab, setSelectedTab] = useState(tabToSelect ?? tabNames.USERS)
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(25)
  const [modalOpen, setModalOpen] = useState(false)
  const [selectedItem, setSelectedItem] = useState({})
  const [selectedApartmentToDelete, setSelectedApartmentToDelete] =
    useState(null)

  const [selectedDoorbellToDelete, setSelectedDoorbellToDelete] = useState(null)

  const [{ buildingState }, { getBuilding }] = useBuildingsApi()
  const [{ getApartmentsFromBuildingState }, apartmentsMethods] =
    useApartmentsApi()
  const [
    { getDoorbellsFromBuildingState, doorbellGroupsState },
    doorbellsMethods,
  ] = useDoorbellsApi()
  const [{ getUsersFromBuildingState }, usersMethods] = useUsersApi()

  const [nameFilter, setNameFilter] = useState('')

  useEffect(() => {
    const fetchData = async () => {
      getBuilding(id)
    }
    fetchData()
  }, [modalOpen])

  const building = buildingState.building

  const renderForm = () => {
    if (selectedTab === tabNames.APARTMENTS) {
      return (
        <ApartmentForm
          apartment={selectedItem}
          onSubmit={(values) => {
            if (values.id) {
              apartmentsMethods.updateApartment({ ...values, buildingId: id })
            } else {
              apartmentsMethods.createApartment({ ...values, buildingId: id })
            }
            setModalOpen(false)
          }}
          handleCancel={() => setModalOpen(false)}
        />
      )
    } else if (selectedTab === tabNames.DOORBELS) {
      return (
        <DoorbellForm
          doorbell={selectedItem}
          onSubmit={(values) => {
            if (!values.imageUpdated) {
              delete values.image
            }
            if (values.id) {
              doorbellsMethods.updateDoorbell({ ...values, buildingId: id })
            } else {
              doorbellsMethods.createDoorbell({ ...values, buildingId: id })
            }
            setModalOpen(false)
          }}
          handleCancel={() => setModalOpen(false)}
        />
      )
    } else if (selectedTab === tabNames.GATES) {
      return (
        <DoorbellForm
          doorbell={selectedItem}
          onSubmit={(values) => {
            if (values.id) {
              doorbellsMethods.updateDoorbell(
                { ...values, buildingId: id },
                true
              )
            } else {
              doorbellsMethods.createDoorbell(
                { ...values, buildingId: id },
                true
              )
            }
            setModalOpen(false)
          }}
          handleCancel={() => setModalOpen(false)}
          isGate
          buildingId={id}
          doorbellGroupsState={doorbellGroupsState}
        />
      )
    } else {
      return (
        <UserForm
          user={selectedItem}
          onSubmit={(values) => {
            if (values.id) {
              usersMethods.updateUser({ ...values, buildingId: id })
            } else {
              usersMethods.createUser({ ...values, buildingId: id })
            }
            setModalOpen(false)
          }}
          handleCancel={() => setModalOpen(false)}
        />
      )
    }
  }

  const options = (item) =>
    [
      ...(selectedTab === tabNames.DOORBELS
        ? [
            {
              key: 'downloadQR',
              label: 'Descargar QR',
              onClick: () => {
                const canvas = document.querySelector(
                  `#Qrcode-${item.id} > canvas`
                )
                const link = document.createElement('a')
                link.href = canvas.toDataURL()
                link.download = `Portero-${item.name}-QR.png`
                link.click()
              },
            },
            {
              key: 'refreshImage',
              label: 'Recargar imagen',
              onClick: () => {
                doorbellsMethods.updateImage(item.id, () =>
                  doorbellsMethods.getDoorbellsFromBuilding(id)
                )
              },
            },
            item.type === DoorbellType.INTELBRAS
              ? {
                  key: 'refresh',
                  label: 'Refrescar datos usuarios',
                  onClick: () => {
                    doorbellsMethods.updateSchedulesDoorbell(item.id)
                  },
                }
              : undefined,
          ]
        : []),
      {
        key: 'edit',
        label: 'Editar',
        onClick: () => {
          let redirectTo
          if (selectedTab === tabNames.USERS) redirectTo = '/nuevo-usuario'
          if (selectedTab === tabNames.APARTMENTS)
            redirectTo = '/nuevo-apartamento'
          if (selectedTab === tabNames.DOORBELS)
            redirectTo = '/nuevo-dispositivo'
          if (selectedTab === tabNames.GATES) redirectTo = '/nuevo-dispositivo'
          history.push(redirectTo, {
            buildingId: id,
            previousRoute: history.location.pathname,
            selectedTab,
            item,
            isGate: selectedTab === tabNames.GATES,
            pathOverride: paths.BUILDINGS,
          })
        },
      },
      {
        key: 'delete',
        label: 'Eliminar',
        onClick: () => {
          if (selectedTab === tabNames.APARTMENTS)
            setSelectedApartmentToDelete(item)
          else if (
            selectedTab === tabNames.DOORBELS ||
            selectedTab === tabNames.GATES
          )
            setSelectedDoorbellToDelete(item)
          else usersMethods.deleteUser(item.id)
        },
      },
    ]?.filter((option) => !!option)

  let countItems
  let columns

  if (selectedTab === tabNames.APARTMENTS) {
    columns = apartmentColumns
  } else if (selectedTab === tabNames.DOORBELS) {
    columns = doorbellColumns
  } else if (selectedTab === tabNames.GATES) {
    countItems = getDoorbellsFromBuildingState.doorbells?.count
    columns = gateColumns
  } else {
    columns = userCollumns
  }

  const renderListHeader = () => {
    let createText
    let redirectUrl
    if (selectedTab === tabNames.USERS) {
      return <></>
    }
    if (selectedTab === tabNames.DOORBELS) {
      createText = 'Crear portero'
      redirectUrl = '/nuevo-dispositivo'
    }
    if (selectedTab === tabNames.GATES) {
      createText = 'Crear portón'
      redirectUrl = '/nuevo-dispositivo'
    }
    if (selectedTab === tabNames.APARTMENTS) {
      createText = 'Crear apartamento'
      redirectUrl = '/nuevo-apartamento'
    }
    return (
      <ListHeader
        createText={createText}
        createRedirect={() => {
          history.push(redirectUrl, {
            buildingId: id,
            previousRoute: history.location.pathname,
            selectedTab,
            isGate: selectedTab === tabNames.GATES,
            pathOverride: paths.BUILDINGS,
          })
        }}
      />
    )
  }

  return (
    <>
      <ListHeader
        smallTitle="Edificios"
        bigTitle={building.name}
        canCreate={false}
        goBack={() => history.push('/edificios')}
      />
      <Tabs
        className={classes.tabs}
        value={selectedTab}
        indicatorColor="primary"
        textColor="primary"
        aria-label="disabled tabs example"
        onChange={(event, value) => setSelectedTab(value)}
      >
        <Tab className={classes.tab} label="Usuarios" value={tabNames.USERS} />
        <Tab
          className={classes.tab}
          label={'Unidades'}
          value={tabNames.APARTMENTS}
        />
        <Tab
          className={classes.tab}
          label="Porteros"
          value={tabNames.DOORBELS}
        />
        <Tab className={classes.tab} label="Portones" value={tabNames.GATES} />
      </Tabs>
      {renderListHeader()}
      {selectedTab === tabNames.GATES && buildingState?.building && (
        <CustomTable
          loading={getDoorbellsFromBuildingState.loading}
          columns={columns}
          data={getDoorbellsFromBuildingState.doorbells?.filter(
            (doorbell) =>
              doorbell.type === DoorbellType.GATE ||
              doorbell.type === DoorbellType.SURIX_GATE
          )}
          getData={() => {
            doorbellsMethods.getDoorbellsFromBuilding(
              buildingState?.building?.id
            )
          }}
          buildingFilter={false}
          building={buildingState?.building}
          apartmentFilter={false}
          searchFilter={'Nombre'}
          options={options}
          serverPagination={false}
          serverCount={countItems}
        ></CustomTable>
      )}
      {selectedTab === tabNames.DOORBELS && buildingState?.building && (
        <CustomTable
          loading={getDoorbellsFromBuildingState.loading}
          columns={columns}
          data={getDoorbellsFromBuildingState.doorbells?.filter(
            (doorbell) =>
              doorbell.type !== DoorbellType.GATE &&
              doorbell.type !== DoorbellType.SURIX_GATE
          )}
          getData={() => {
            doorbellsMethods.getDoorbellsFromBuilding(
              buildingState?.building?.id
            )
          }}
          buildingFilter={false}
          building={buildingState?.building}
          apartmentFilter={false}
          searchFilter={'Nombre'}
          options={options}
          serverPagination={false}
          serverCount={countItems}
        ></CustomTable>
      )}
      {selectedTab === tabNames.APARTMENTS && buildingState?.building && (
        <CustomTable
          loading={getApartmentsFromBuildingState.loading}
          columns={columns}
          data={getApartmentsFromBuildingState?.apartments}
          getData={() => {
            apartmentsMethods.getApartmentsFromBuilding(
              buildingState?.building?.id
            )
          }}
          buildingFilter={false}
          building={buildingState?.building}
          apartmentFilter={false}
          searchFilter={'Nombre'}
          options={options}
          serverPagination={false}
          serverCount={countItems}
        ></CustomTable>
      )}
      {selectedTab === tabNames.USERS && buildingState?.building?.id && (
        <UserList
          building={building}
          redirectTo={history.location.pathname}
          withTitle={false}
          pathOverride={paths.BUILDINGS}
        />
      )}
      <Modal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        aria-labelledby="simple-modal-title"
      >
        {renderForm()}
      </Modal>
      <DeleteConfirmationModal
        open={!!selectedApartmentToDelete}
        invitation={selectedApartmentToDelete}
        onClose={() => setSelectedApartmentToDelete(null)}
        onDelete={(apartment) => {
          apartmentsMethods.deleteApartment(apartment.id)
          setSelectedApartmentToDelete(null)
        }}
      />
      <DeleteConfirmationModal
        open={!!selectedDoorbellToDelete}
        invitation={selectedDoorbellToDelete}
        onClose={() => setSelectedDoorbellToDelete(null)}
        onDelete={(doorbell) => {
          doorbellsMethods.deleteDoorbell(
            doorbell.id,
            selectedTab === tabNames.GATES
          )
          setSelectedDoorbellToDelete(null)
        }}
      />
    </>
  )
}

const useStyles = makeStyles({
  addButton: {
    position: 'absolute',
    right: '32px',
    bottom: '32px',
  },
  grid: {
    border: 'solid 1px grey',
    borderRadius: '8px',
    paddingBottom: '12px',
    textAlign: 'left',
    paddingLeft: '32px',
  },
  gridItem: {
    padding: '6px',
    paddingLeft: '32px',
  },
  tabs: {
    margin: '24px 0',
  },
  tab: {
    textTransform: 'none',
    fontSize: '16px',
  },
  checkbox: {
    marginLeft: '8px',
  },
  searchWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '0 20px 20px 20px',
  },
})
// {selectedTab !== tabNames.USERS && (
//   <>
//     {/* <CustomTable
//       loading={isLoading}
//       columns={columns}
//       data={tableData}
//       getData={(params) => {
//         apartmentsMethods.getApartmentsFromBuilding(id)
//         doorbellsMethods.getDoorbellsFromBuilding(id)
//       }}
//       buildingFilter={false}
//       building={false}
//       apartmentFilter={false}
//       searchFilter={'Nombre, o SIP URL'}
//       options={options}
//       serverPagination={false}
//       serverCount={countItems}
//     ></CustomTable> */}
//     {/* <TableContainer className={classes.container}>
//       <Table stickyHeader aria-label="sticky table">
//         <TableHead>
//           <TableRow>
//             {columns.map((column) => (
//               <TableCell
//                 key={column.id}
//                 align={column.align}
//                 style={{ minWidth: column.minWidth }}
//               >
//                 {column.label}
//               </TableCell>
//             ))}
//           </TableRow>
//         </TableHead>
//         <TableBody>
//           {items?.map((item) => {
//             return (
//               <TableRow hover role="checkbox" tabIndex={-1} key={item.id}>
//                 {columns.map((column) => {
//                   if (column.id === 'isEntrance') {
//                     return (
//                       <TableCell
//                         style={{ width: '70px' }}
//                         key={column.id}
//                         align={column.align}
//                       >
//                         {item[column.id] ? 'Entrada' : 'Salida'}
//                       </TableCell>
//                     )
//                   }
//                   if (column.id === 'portraitFormat') {
//                     return (
//                       <TableCell
//                         style={{ width: '70px' }}
//                         key={column.id}
//                         align={column.align}
//                       >
//                         {item[column.id] ? 'Si' : 'No'}
//                       </TableCell>
//                     )
//                   }
//                   if (column.id === 'groupId') {
//                     return (
//                       <TableCell
//                         style={{ width: '70px' }}
//                         key={column.id}
//                         align={column.align}
//                       >
//                         {doorbellGroupsState?.doorbellGroups &&
//                         doorbellGroupsState?.doorbellGroups.find(
//                           (group) => group.id === item[column.id]
//                         )?.name
//                           ? doorbellGroupsState?.doorbellGroups.find(
//                               (group) => group.id === item[column.id]
//                             )?.name
//                           : '-'}
//                       </TableCell>
//                     )
//                   }
//                   if (column.id === 'image') {
//                     return (
//                       <TableCell
//                         style={{ width: '70px' }}
//                         key={column.id}
//                         align={column.align}
//                       >
//                         {item[column.id] ? (
//                           <img
//                             src={item[column.id]}
//                             alt="doorbell img"
//                             style={{ width: '70px' }}
//                           ></img>
//                         ) : (
//                           <p style={{ textAlign: 'center' }}>
//                             Sin imagen
//                           </p>
//                         )}
//                       </TableCell>
//                     )
//                   }
//                   if (!column.id) {
//                     return (
//                       <TableCell
//                         style={{ width: '58px' }}
//                         key={column.id}
//                         align={column.align}
//                       >
//                         <MoreOptions options={options(item)} />
//                       </TableCell>
//                     )
//                   }
//                   const value = item[column.id]
//                   if (column.id === 'enabled')
//                     return (
//                       <TableCell key={column.id} align={column.align}>
//                         <Checkbox
//                           checked={value}
//                           color="primary"
//                           inputProps={{
//                             'aria-label': 'secondary checkbox',
//                           }}
//                           disabled
//                           className={classes.checkbox}
//                         />
//                       </TableCell>
//                     )
//                   if (column.id === 'id') {
//                     return (
//                       <TableCell key={column.id} align={column.align}>
//                         <img
//                           src={CopyIcon}
//                           alt="copy to clipboard"
//                           style={{
//                             height: '20px',
//                             width: '20px',
//                             cursor: 'pointer',
//                           }}
//                           onClick={() => {
//                             copy(value)
//                             addToast(
//                               notificationTypes.success,
//                               'Id del Portero copiado con exito!'
//                             )
//                           }}
//                         ></img>
//                         <div id={`Qrcode-${value}`}>
//                           <QRCodeCanvas
//                             size={1024}
//                             style={{ display: 'none' }}
//                             value={`${window.location.origin}/requestAccess/${value}`}
//                           />
//                         </div>
//                       </TableCell>
//                     )
//                   }
//                   return (
//                     <TableCell key={column.id} align={column.align}>
//                       {column.format && typeof value === 'number'
//                         ? column.format(value)
//                         : value}
//                     </TableCell>
//                   )
//                 })}
//               </TableRow>
//             )
//           })}
//         </TableBody>
//       </Table>
//     </TableContainer>
//     <TablePagination
//       rowsPerPageOptions={[25, 50, 100]}
//       component="div"
//       count={countItems || items?.length}
//       rowsPerPage={rowsPerPage}
//       page={page}
//       onChangePage={handleChangePage}
//       onChangeRowsPerPage={handleChangeRowsPerPage}
//     /> */}
//     <Fab
//       color="primary"
//       aria-label="add"
//       className={classes.addButton}
//       onClick={() => {
//         setSelectedItem({})
//         setModalOpen(true)
//       }}
//     >
//       <AddIcon />
//     </Fab>
//   </>
// )}
